import Vue from "vue";
import VueRouter from "vue-router";
import Router from "vue-router";
import { syncSessionIdentity } from "@/utils/sessionIdentity";
import { resolveComicAiPublicPath } from "@/micro/resolve";

Vue.use(VueRouter);
//添加以下代码
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/scriptPage",
    name: "scriptPage",
    meta: { titleKey: "route.scriptPage" },
    component: () => import("../views/scriptPage/scriptPage.vue"),
  },
  {
    path: "/storyboard",
    name: "storyboard",
    meta: { titleKey: "route.storyboard" },
    component: () => import("../views/scriptPage/storyBoard.vue"),
  },
  {
    path: "/scriptPreviewPage",
    name: "scriptPreview",
    meta: { titleKey: "route.scriptPreview" },
    component: () => import("../views/scriptPage/scriptPreviewPage.vue"),
  },
  // {
  //   path: "/",
  //   name: "流量探测器",
  //   component: () => import("../views/home/home.vue"),
  // },
  {
    path: "/copywritingCreation",
    name: "copywritingCreation",
    meta: { titleKey: "route.copywritingCreation" },
    component: () => import("../views/creation/creation.vue"),
  },
  //   {
  //   path: "/videoCreation",
  //   name: "视频创作",
  //   component: () => import("../views/creation/creation.vue"),
  // },
  {
    path: "/detectionResult",
    name: "detectionResult",
    meta: { titleKey: "route.detectionResult" },
    component: () => import("../views/detectionResult/detectionResult.vue"),
  },

  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    meta: { titleKey: "route.home" },
    component: () => import("../views/home/home.vue"),
  },
  {
    path: "/myProject",
    name: "myProject",
    meta: { titleKey: "route.myProject" },
    component: () => import("../views/myProject/myProject.vue"),
  },
  {
    path: "/projectManagement",
    name: "projectManagement",
    meta: { titleKey: "route.projectManagement" },
    component: () => import("../views/projectManagement/projectManagement.vue"),
  },
  {
    path: "/hotRanking",
    name: "hotRanking",
    meta: { titleKey: "route.hotRanking" },
    component: () => import("../views/hotRanking/hotRanking.vue"),
  },
  {
    path: "/statisticalDimension",
    name: "statisticalDimension",
    meta: { titleKey: "route.statisticalDimension" },
    component: () =>
      import("../views/statisticalDimension/statisticalDimension.vue"),
  },
  {
    path: "/visionCanvas",
    name: "visionCanvas",
    meta: { titleKey: "route.visionCanvas" },
    component: () =>
      import("../views/visionCanvas/visionProjectLibrary.vue"),
  },
  // 画布项目组工作台
  {
    path: "/visionCanvas/group/:id",
    name: "canvasGroupWorkbench",
    meta: {
      titleKey: "route.projectGroupWorkbench",
      scene: "canvas",
    },
    component: () =>
      import("../views/projectGroupWorkbench/ProjectGroupWorkbench.vue"),
  },
  {
    path: "/visionCanvas/editor",
    name: "visionCanvasEditor",
    meta: {
      titleKey: "route.visionCanvasEditor",
      hideHeader: true,
    },
    component: () => import("../views/visionCanvas/MicroAppContainer.vue"),
    beforeEnter(to, from, next) {
      const token = window.localStorage.getItem("token");
      if (!token) {
        next("/login");
        return;
      }
      next();
    },
  },
  {
    path: "/roleManagement",
    name: "roleManagement",
    meta: { titleKey: "route.roleManagement" },
    component: () => import("../views/management/roleManagement.vue"),
  },
  {
    path: "/sceneManagement",
    name: "sceneManagement",
    meta: { titleKey: "route.sceneManagement" },
    component: () => import("../views/management/sceneManagement.vue"),
  },
  {
    path: "/propManagement",
    name: "propManagement",
    meta: { titleKey: "route.propManagement" },
    component: () => import("../views/management/propManagement.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: {
      titleKey: "route.login",
      hideHeader: true,
    },
    component: () =>
      process.env.VUE_APP_LOGO_IMAGE === "logo-manyu"
        ? import("../views/login/home.vue")
        : import("../views/login/login.vue"),
  },
  {
    path: "/team-invite",
    name: "teamInviteRegister",
    meta: {
      titleKey: "route.login",
      hideHeader: true,
    },
    component: () => import("../views/login/TeamInviteRegisterPage.vue"),
  },
  // 项目组邀请落地页：有效/失效同一路由，是否失效留给详情接口判断
  {
    path: "/project-group/invite",
    name: "projectGroupInvite",
    meta: {
      titleKey: "route.projectGroupInvite",
      hideHeader: true,
      requiresAuth: true,
    },
    component: () =>
      import("../views/projectGroupInvite/ProjectGroupInvite.vue"),
  },
  // 旧分享地址 /project-group-invite 收进新路径，query 原样带走
  {
    path: "/project-group-invite",
    redirect: (to) => ({
      path: "/project-group/invite",
      query: to.query,
    }),
  },
  {
    path: "/userManagement",
    name: "userManagement",
    meta: { titleKey: "route.userManagement" },
    component: () => import("../views/userManagement/userManagement.vue"),
  },
  {
    path: "/teamManagement",
    name: "teamManagement",
    meta: { titleKey: "route.teamManagement" },
    component: () => import("../views/teamManagement/teamManagement.vue"),
  },
  {
    path: "/invoice",
    name: "invoice",
    meta: { titleKey: "route.invoice" },
    component: () => import("../views/invoice/index.vue"),
  },
];

const router = new VueRouter({
  routes,
});

function getLinkToken(query = {}) {
  const token = query.linkToken;
  if (Array.isArray(token)) {
    return token[0] || "";
  }
  return token || "";
}

function getSearchLinkToken() {
  if (typeof window === "undefined" || !window.location) {
    return "";
  }
  const params = new URLSearchParams(window.location.search || "");
  return params.get("linkToken") || "";
}

/** 登录前暂存需返回的站内地址，避免剥掉 hash 后 $route.query.redirect 丢失 */
const LOGIN_REDIRECT_STORAGE_KEY = "comicAiLoginRedirect";

/** 只收站内相对路径，拒绝协议相对地址 */
function sanitizeLoginRedirect(raw) {
  const value = String(raw || "").trim();
  if (!value.startsWith("/") || value.startsWith("//")) {
    return "";
  }
  return value;
}

/** 未登录被踢去登录页时记下原地址，登录成功再读 */
function saveLoginRedirect(raw) {
  const value = sanitizeLoginRedirect(raw);
  if (typeof window === "undefined" || !window.sessionStorage || !value) {
    return;
  }
  window.sessionStorage.setItem(LOGIN_REDIRECT_STORAGE_KEY, value);
}

/** 登录成功或离开邀请流程后清掉回跳，避免下次普通登录仍被拉回邀请页 */
export function clearLoginRedirect() {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return;
  }
  window.sessionStorage.removeItem(LOGIN_REDIRECT_STORAGE_KEY);
}

/** 用当前地址栏的邀请分享路径拼回跳地址（hash 被剥掉后仍能回到落地页） */
function getHistoryInviteSharePath() {
  const target = getHistoryInviteTarget();
  if (!target) {
    return "";
  }
  const params = new URLSearchParams();
  Object.keys(target.query || {}).forEach((key) => {
    const value = target.query[key];
    if (value != null && value !== "") {
      params.set(key, String(value));
    }
  });
  const search = params.toString();
  return `${target.path}${search ? `?${search}` : ""}`;
}

/** 登录成功后只允许跳回站内相对路径，避免开放重定向 */
export function getSafeLoginRedirect(query = {}) {
  const raw = Array.isArray(query.redirect) ? query.redirect[0] : query.redirect;
  const stored =
    typeof window !== "undefined" && window.sessionStorage
      ? window.sessionStorage.getItem(LOGIN_REDIRECT_STORAGE_KEY)
      : "";
  // 路由 query → session → 地址栏邀请链接，后者兜住剥 hash 后 redirect 丢失
  const candidates = [raw, stored, getHistoryInviteSharePath()];
  for (let i = 0; i < candidates.length; i += 1) {
    const value = sanitizeLoginRedirect(candidates[i]);
    if (value) {
      return value;
    }
  }
  return "";
}

/** 无 hash 邀请落地页（含旧路径），hash 模式打开后 pathname 会一直停在这里 */
function isHistoryInvitePathname() {
  if (typeof window === "undefined" || !window.location) {
    return false;
  }
  const pathname = String(window.location.pathname || "");
  // 允许 /client 这类 # 前部署前缀，只认路径末尾的邀请落地段
  return (
    /\/project-group\/invite\/?$/.test(pathname) ||
    /\/project-group-invite\/?$/.test(pathname) ||
    /\/join\/[^/?#]+\/[^/?#]+\/?$/.test(pathname)
  );
}

/** 无 hash 的分享地址收进 /#/project-group/invite，旧路径一并兼容 */
function getHistoryInviteTarget() {
  if (typeof window === "undefined" || !window.location) {
    return null;
  }
  if (!isHistoryInvitePathname()) {
    return null;
  }
  const pathname = String(window.location.pathname || "");
  const query = {};
  new URLSearchParams(window.location.search || "").forEach((value, key) => {
    query[key] = value;
  });
  // 新路径和已发出的 /project-group-invite 都落到同一邀请页
  if (
    /\/project-group\/invite\/?$/.test(pathname) ||
    /\/project-group-invite\/?$/.test(pathname)
  ) {
    return { path: "/project-group/invite", query };
  }
  const legacy = pathname.match(/\/join\/([^/?#]+)\/([^/?#]+)\/?$/);
  if (!legacy) {
    return null;
  }
  // 旧链接的 scene/id 改挂 query，仍落到同一邀请页
  return {
    path: "/project-group/invite",
    query: {
      ...query,
      scene: query.scene || legacy[1],
      id: query.id || legacy[2],
    },
  };
}

/**
 * hash 模式会叠出 path?query#/path?query。
 * 落地页 pathname 已经是分享地址时，去掉 hash，地址栏保持复制出去的链接。
 */
function stripInviteShareHash() {
  if (
    typeof window === "undefined" ||
    !window.location ||
    !window.history ||
    !isHistoryInvitePathname() ||
    !window.location.hash
  ) {
    return;
  }
  const shareUrl = `${window.location.pathname}${window.location.search}`;
  window.history.replaceState(window.history.state, document.title, shareUrl);
}

/**
 * 离开邀请落地页时，把 pathname 收成部署前缀 + hash，避免后续路由变成
 * /client/project-group/invite?token=xxx#/home。
 */
function normalizeHistoryInviteExitUrl(to) {
  if (
    typeof window === "undefined" ||
    !window.location ||
    !window.history ||
    !isHistoryInvitePathname()
  ) {
    return;
  }
  const fullPath = (to && to.fullPath) || "/home";
  const hashPath = fullPath.startsWith("/") ? fullPath : `/${fullPath}`;
  // 保留 /client 这类 # 前服务器后缀，根路径部署时前缀为空
  const publicPath = resolveComicAiPublicPath();
  window.history.replaceState(
    window.history.state,
    document.title,
    `${publicPath}/#${hashPath}`,
  );
}

function getTeamInviteToken(query = {}) {
  const routeToken = Array.isArray(query.teamInviteToken)
    ? query.teamInviteToken[0]
    : query.teamInviteToken;
  const searchToken =
    typeof window !== "undefined" && window.location
      ? new URLSearchParams(window.location.search).get("teamInviteToken")
      : "";
  return String(routeToken || searchToken || "").trim();
}

function saveLinkToken(token) {
  if (typeof window === "undefined" || !window.sessionStorage || !token) {
    return;
  }
  window.sessionStorage.setItem("linkToken", token);
}

function clearSearchLinkToken() {
  if (
    typeof window === "undefined" ||
    !window.location ||
    !window.history ||
    !window.location.search
  ) {
    return;
  }
  const url = new URL(window.location.href);
  if (!url.searchParams.has("linkToken")) {
    return;
  }
  url.searchParams.delete("linkToken");
  const search = url.searchParams.toString();
  const cleanUrl = `${url.pathname}${search ? `?${search}` : ""}${url.hash}`;
  window.history.replaceState(window.history.state, document.title, cleanUrl);
}

/** 登录/注册进入业务页后清掉邀请 linkToken（地址栏 + sessionStorage） */
export function clearInviteLinkState() {
  if (typeof window !== "undefined") {
    window.__pendingInviteUrl = "";
    if (window.sessionStorage) {
      window.sessionStorage.removeItem("linkToken");
    }
  }
  clearSearchLinkToken();
}

function getInviteShareUrl() {
  if (typeof window === "undefined" || !window.location) {
    return "";
  }
  return `${window.location.pathname}${window.location.search}`;
}

function keepInviteShareUrl(url) {
  if (typeof window === "undefined" || !url) {
    return;
  }
  window.__pendingInviteUrl = url;
}

function restoreInviteShareUrl() {
  if (typeof window === "undefined" || !window.history) {
    return;
  }
  const inviteUrl = window.__pendingInviteUrl;
  if (!inviteUrl) {
    return;
  }
  window.__pendingInviteUrl = "";
  window.history.replaceState(window.history.state, document.title, inviteUrl);
}

// 无 hash 邀请链接只收一次；登录跳转 / 离开落地页时 pathname 还在，不能再按 pathname 强拉回来
let historyInviteResolved = false;

router.beforeEach((to, from, next) => {
  // 切路由时兜底：其它窗口已换账号则刷新，避免页面数据与 header 撕裂
  if (syncSessionIdentity()) {
    next(false);
    return;
  }

  // 地址栏是邀请落地页而不是 hash 时，先收进内部路由；只处理一次
  const historyInvite = getHistoryInviteTarget();
  if (historyInvite && !historyInviteResolved && to.path !== historyInvite.path) {
    historyInviteResolved = true;
    // 先记下邀请地址，未登录转登录后还能跳回来
    saveLoginRedirect(getHistoryInviteSharePath());
    next({
      path: historyInvite.path,
      query: historyInvite.query,
      replace: true,
    });
    return;
  }
  if (historyInvite) {
    historyInviteResolved = true;
  }

  const teamInviteToken = getTeamInviteToken(to.query);
  if (teamInviteToken) {
    if (to.path !== "/team-invite") {
      next({
        path: "/team-invite",
        query: new URLSearchParams(window.location.search).has("teamInviteToken")
          ? {}
          : { teamInviteToken },
        replace: true,
      });
      return;
    }
    next();
    return;
  }

  // 项目组邀请等需登录页：未登录先去登录，并把原地址放进 redirect
  if (to.matched.some((record) => record.meta && record.meta.requiresAuth)) {
    const token =
      typeof window !== "undefined"
        ? window.localStorage.getItem("token")
        : "";
    if (!token) {
      // 同步写入 session，避免登录页剥 hash 后 query.redirect 读不到
      saveLoginRedirect(to.fullPath);
      next({
        path: "/login",
        query: { redirect: to.fullPath },
        replace: true,
      });
      return;
    }
  }

  const routeLinkToken = getLinkToken(to.query);
  const searchLinkToken = getSearchLinkToken();
  const linkToken = routeLinkToken || searchLinkToken;
  if (!linkToken) {
    next();
    return;
  }

  saveLinkToken(linkToken);

  // /?linkToken=xxx 分享链接：内部进入注册页，地址栏保持邀请 URL，不跳成 /#/login
  if (searchLinkToken) {
    const inviteUrl = getInviteShareUrl();
    const isInitialNavigation = from.matched.length === 0;

    if (to.path === "/login") {
      keepInviteShareUrl(inviteUrl);
      if (to.query.register !== "1") {
        next({
          path: "/login",
          query: {
            ...to.query,
            register: "1",
          },
          replace: true,
        });
        return;
      }
      next();
      return;
    }

    // 仅首次进入时挂载登录/注册页；之后允许正常跳转，避免被反复拉回
    if (isInitialNavigation) {
      keepInviteShareUrl(inviteUrl);
      next({
        path: "/login",
        query: {
          register: "1",
        },
        replace: true,
      });
      return;
    }

    next();
    return;
  }

  if (to.path === "/login" && to.query.register === "1" && routeLinkToken) {
    next();
    return;
  }

  clearSearchLinkToken();
  next({
    path: "/login",
    query: {
      ...to.query,
      linkToken,
      register: "1",
    },
    replace: true,
  });
});

router.afterEach((to) => {
  if (to.path === "/login") {
    restoreInviteShareUrl();
    // 从项目组邀请落地页被踢去登录时，地址栏仍保持复制出去的无 hash 链接
    stripInviteShareHash();
    return;
  }
  if (to.path === "/project-group/invite") {
    restoreInviteShareUrl();
    // 内部已是 hash 路由，地址栏去掉叠上去的 #/project-group/invite
    stripInviteShareHash();
    return;
  }
  // 离开邀请落地页后收成 /#/业务路径，避免 pathname 残留
  normalizeHistoryInviteExitUrl(to);
  // 离开登录/注册页后不再保留 linkToken 和登录回跳
  clearInviteLinkState();
  clearLoginRedirect();
});

export default router;
